import './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { reactErrorHandler } from '@sentry/react';

import './index.css';

import App from './App';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme';
import { initExperiments } from './experiments/remoteConfig';
import { bootDebugOverlay } from './experiments/debugOverlay';

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// Experiments boot: mint the visitor id so the cookie starts ageing now,
// apply the cached remote document before first paint, and fetch a fresh one
// in the background. Fail-open: never throws, never blocks render.
initExperiments();
// Opens the experiments debug panel when the URL carries ?expdebug=1.
bootDebugOverlay();

const root = ReactDOM.createRoot(document.getElementById('root'), {
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
});

const loadGoogleMapsScript = () => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    return;
  }

  const existingScript = document.querySelector(
    `script[src^="https://maps.googleapis.com/maps/api/js"]`
  );
  if (existingScript) return;

  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
};

loadGoogleMapsScript();

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
